// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".creative-management-mf .bulk-video-upload .dz-details{text-align:center!important}.creative-management-mf .bulk-video-upload .dz-filename{display:block!important;color:#3367d6!important}.creative-management-mf .bulk-video-upload .dz-progress{display:none!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
